import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, Field } from 'redux-form';

import { init } from './grupoFisicoActions';
import LabelAndInput from '../common/form/labelAndInput';
import Button from '../common/form/button';

class GrupoFisicoForm extends Component {


    render() {
        // os eventos handleSubmit, vem do reduxForm
        const { handleSubmit } = this.props;
        const premiumForm = this.props.premiumLayout === true;

        return (
            <form onSubmit={handleSubmit} autocomplete="off" className={premiumForm ? 'simple-cad-form-premium' : ''}>
                <div className={premiumForm ? 'simple-cad-premium-container' : 'box-body'}>
                    <div className={premiumForm ? 'simple-cad-premium-card' : ''}>
                        {premiumForm && (
                            <div className="simple-cad-premium-header">
                                <h4><i className="fa fa-server" /> Grupo Físico</h4>
                                <p>Informe os dados principais para cadastrar um novo grupo físico.</p>
                            </div>
                        )}
                        <div className={premiumForm ? 'simple-cad-premium-body' : ''}>
                            <Field name='id' component={LabelAndInput} readOnly={true}
                                label='Código' cols={premiumForm ? '12 4' : '12'} placeholder='Automático' />
                            <Field name='descricao' component={LabelAndInput}
                                label='Descrição' cols={premiumForm ? '12 8' : '12'} placeholder='Informe a descrição' />
                        </div>
                    </div>
                </div>
                <div className={premiumForm ? 'simple-cad-premium-footer' : 'box-footer'}>
                    <Button type='submit' className={this.props.submitClass} icon='check' label={this.props.submitLabel} />
                    <Button type='button' className='default' icon='close' label='Cancelar' onClick={this.props.init} />
                </div>
            </form>
        )
    }
}

// destroyOnUnmount: false permite utilizar o mesmo componente form para cadastrar e para alterar, se tirar essa propriedade o sistema cria um 
// form limpo para o update
GrupoFisicoForm = reduxForm({ form: 'grupoFisicoForm', destroyOnUnmount: false })(GrupoFisicoForm);

const mapDispatchToProps = dispatch => bindActionCreators({ init }, dispatch);
export default connect(null, mapDispatchToProps)(GrupoFisicoForm);